import { useEffect, useState } from 'react';

import { putLanguageData } from 'src/services/apiRequests/LanguageService';
import { Countrylist } from 'src/services/responseTypes/singleLaunchResponse';
import { colors } from 'src/styles/colors';
import {
  disableBackgroundScrolling,
  enableBackgroundScrolling
} from 'src/utils/common';

import { useAppStore } from 'src/hooks/useAppStore';
import ToastMessage from '../toastMessage';
import {
  getAutomaticAgeRating,
  stringFormatAgeRating
} from './parentalControlHelper';
import PinComponent from './PinComponent';
import PinUpdateSuccess from './PinUpdateSuccess';
import * as styles from './SetUpParentalPinStyle';

interface SetUpParentalPinProps {
  submitHandle: (status: boolean, parentalValue: string) => void;
}

const SetUpParentalPin: React.FC<SetUpParentalPinProps> = ({
  submitHandle
}) => {
  const [pin, setPin] = useState<string>('');
  const [confirmPin, setConfirmPin] = useState<string>('');
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [toastMsg, setToastMsg] = useState<string>('');
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [pinUpdateStatusCode, setPinUpdateStatusCode] = useState<
    number | undefined
  >();

  const { translations, initialLaunchData } = useAppStore();
  const ParentalControlStrings = translations?.common?.PARENTAL_CONTROL;

  // countrylist
  const countryList: Countrylist | undefined =
    initialLaunchData?.country_config;

  // ageRatingObj
  const ageRatingObj = countryList?.age_rating_v2;

  // automatic age rating for few countries
  const automaticAgeRating = getAutomaticAgeRating(countryList);

  const handlePinComplete = (pin: string) => {
    setPin(pin);
  };

  const handleConfirmPinComplete = (pin: string) => {
    setConfirmPin(pin);
  };

  useEffect(() => {
    disableBackgroundScrolling();
  }, []);

  useEffect(() => {
    if (toastMsg) {
      setTimeout(() => {
        setToastMsg('');
        if (pinUpdateStatusCode === 1) {
          // api call
        }
        setPinUpdateStatusCode(undefined);
      }, 2000);
    }
  }, [toastMsg]);

  const handleParentPopupBtn = () => {
    if (confirmPin === pin) {
      let parentalApiValue = '';
      if (automaticAgeRating !== undefined) {
        parentalApiValue = stringFormatAgeRating(`${automaticAgeRating}`, pin);
      }
      const pinUpdateSettings = putLanguageData(
        'parental_control_v2',
        parentalApiValue
      );
      pinUpdateSettings
        .then((result) => {
          setToastMsg(result.message);
          setPinUpdateStatusCode(result.code);
          setIsSuccess(true);
          setTimeout(() => {
            enableBackgroundScrolling();
            submitHandle(false, parentalApiValue);
          }, 3000);
        })
        .catch((error) => {
          setToastMsg(error.message);
          setPinUpdateStatusCode(error.code);
        });
    }
  };

  const toggleChange = () => {
    setIsChecked(!isChecked);
  };

  return (
    <>
      {isSuccess ? (
        <PinUpdateSuccess z5Strings={ParentalControlStrings} />
      ) : (
        <div css={styles.setUpParentalPinPopup}>
          <div css={styles.setUpParentalPinPopupContent}>
            <div css={styles.setUpParentalPinWrap}>
              <h2 css={styles.popupTitle}>
                {ParentalControlStrings.CreatePin_Header_Text}
              </h2>
              <div css={styles.popupDesc}>
                {ParentalControlStrings.GOV_MANDATE_MSG.replace(
                  '{{age}}',
                  automaticAgeRating
                )}
              </div>
              <div css={styles.pinWrap}>
                <h3 css={styles.popupSubTitle}>
                  {ParentalControlStrings.CreatePin_Enter_Text}
                </h3>
                <PinComponent
                  onComplete={handlePinComplete}
                  width="62px"
                  border={colors.PurpleBtn}
                />
                <h3 css={styles.popupSubTitle}>
                  {ParentalControlStrings.CreatePin_Re_Enter_Text}
                </h3>
                <PinComponent
                  onComplete={handleConfirmPinComplete}
                  width="62px"
                  border={
                    pin?.length === 4 &&
                    confirmPin?.length === 4 &&
                    pin !== confirmPin
                      ? colors.AccentPromoCodeFailureColor
                      : colors.PurpleBtn
                  }
                />
                <styles.incorrectPin
                  className={
                    pin?.length === 4 &&
                    confirmPin?.length === 4 &&
                    pin !== confirmPin
                      ? 'show'
                      : ''
                  }>
                  {ParentalControlStrings.CreatePin_IncorrectPin_Text}
                </styles.incorrectPin>
              </div>
              <label htmlFor="setPin" css={styles.termsMsg}>
                <input
                  id="setPin"
                  type="checkbox"
                  checked={isChecked}
                  onChange={toggleChange}
                  css={styles.checkboxInput}
                />
                <styles.checkboxMark checked={isChecked} />
                {ParentalControlStrings.CreatePin_Terms_Text.replace(
                  '{{age}}',
                  automaticAgeRating
                )}
              </label>
              <styles.popupBtn
                onClick={handleParentPopupBtn}
                disabled={
                  pin?.length < 4 ||
                  confirmPin?.length < 4 ||
                  pin !== confirmPin ||
                  !isChecked
                }>
                {ParentalControlStrings.CreatePin_Save_Button_Text}
              </styles.popupBtn>
              {toastMsg ? <ToastMessage message={toastMsg} /> : null}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SetUpParentalPin;
